package com.anjuros.website.templates.template8.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.util.Res


import com.anjuros.website.templates.template8.modules.Template8Section
import com.anjuros.website.templates.template8.styles.Template8MenuWidthStyle
import com.anjuros.website.templates.template8.styles.Template8NavigationItemStyle
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.getColorOpacity
import com.anjuros.website.templates.template8.util.Template8CompanyDetails
import com.anjuros.website.templates.template8.util.Template8Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8OverflowMenu(onMenuClosed:()->Unit){

    val breakPoint = rememberBreakpoint()
    val scope = rememberCoroutineScope()
    var translateX by remember { mutableStateOf((-100).percent) }
    var opacity by remember { mutableStateOf(0.percent) }

    LaunchedEffect(breakPoint){
        translateX=0.percent
        opacity=100.percent
        if(breakPoint > Breakpoint.MD) {
            scope.launch {
                translateX=(-100).percent
                opacity=0.percent
                delay(500)
                onMenuClosed()
            }
        }
    }

    Column(modifier = Modifier
        .fillMaxWidth()
        .height(100.vh)
        .position(Position.Fixed)
        .zIndex(105)
        .opacity(opacity)
        .backgroundColor(argb(a=0.5f,r=0.0f,g=0.0f,b=0.0f))
        .transition(Transition.of(property = "opacity", duration = 500.ms))) {

        Column(modifier = Template8MenuWidthStyle.toModifier()
            .padding(25.px)
            .overflow(Overflow.Auto)
            .borderRadius(bottomRight = 20.px)
            .scrollBehavior(ScrollBehavior.Smooth)
            .backgroundColor(Template8Theme.Opacity.getColorOpacity())
            .translateX(tx=translateX)
            .transition(Transition.of(property = "translate", duration = 500.ms))){

            Row(
                modifier = Modifier
                    .margin(bottom = 25.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Start
            ){

                Image(
                    modifier =  Modifier
                        .cursor(Cursor.Pointer)
                        .margin(right = 10.px, bottom = 3.px)
                        .onClick {
                            scope.launch {
                                translateX=(-100).percent
                                opacity=0.percent
                                delay(500)
                                onMenuClosed()
                            }
                        },
                    src = Res.Icon.icon_x,
                    alt = "Close menu"
                )

            }

            Template8Section.entries.toTypedArray().forEach { section->
                Link(
                    modifier = Modifier
                        .textDecorationLine(TextDecorationLine.None),

                    path =  section.path,

                    openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE
                ){
                    P(
                        attrs = Template8NavigationItemStyle.toModifier()
                            .margin(bottom = 10.px)
                            .fontFamily(Template8Constants.FONT_FAMILY)
                            .fontSize(16.px)
                            .color(Template8Theme.DarkGrey.rgb)
                            .fontWeight(FontWeight.Normal)
                            .onClick {
                                scope.launch {
                                    translateX=(-100).percent
                                    opacity=0.percent
                                    delay(500)
                                    onMenuClosed()
                                }
                            }
                            .toAttrs()
                    ) {
                        Text(LocalText(section.title))
                    }
                }

            }
            Template8SmallHeaderCall(modifier = Modifier)
        }

    }
}
@Composable
fun Template8SmallHeaderCall(modifier: Modifier){
    Link(path = "tel:${Template8Constants.CLIENTS_PHONE}",
        modifier=modifier.textDecorationLine(TextDecorationLine.None)
            .margin(right = 20.px)) {

        P(
            attrs = Modifier
                .fillMaxWidth()
                .color(Template8Theme.DarkGrey.rgb)
                .textAlign(TextAlign.Center)

                .margin(topBottom = 0.px)
                .fontFamily(Template8Constants.FONT_FAMILY)
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            Text("Call us: ")
            AnjurosText(Template8CompanyDetails.CLIENTS_PHONE_INFO)

        }
    }
}